/**
 * Norwegian number/time formatting for the admin village panels.
 *
 * Hand-rolled instead of Intl.NumberFormat('nb-NO') so the output is
 * byte-for-byte predictable across browsers and in jsdom: thousands are
 * grouped with a NON-BREAKING space (U+00A0) so "7 960 kr" never wraps in
 * the middle of a number on a narrow card.
 */

export const NBSP = '\u00A0';

/** Integer with Norwegian thousands grouping: 7960 → "7 960" (NBSP). */
export function formatCount(value) {
  if (value == null || value === '') return '–';
  const n = Number(value);
  if (!Number.isFinite(n)) return '–';
  const abs = Math.abs(Math.round(n));
  const digits = String(abs);
  const groups = [];
  for (let end = digits.length; end > 0; end -= 3) {
    groups.unshift(digits.slice(Math.max(0, end - 3), end));
  }
  return (n < 0 ? '-' : '') + groups.join(NBSP);
}

/** Øre → whole kroner with grouping and unit: 796000 → "7 960 kr". */
export function formatKr(ore) {
  if (ore == null || ore === '') return '–';
  const n = Number(ore);
  if (!Number.isFinite(n)) return '–';
  return `${formatCount(Math.round(n / 100))}${NBSP}kr`;
}

/** Local wall-clock "HH:MM" (24h) for the "sist oppdatert" indicator. */
export function formatClock(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '--:--';
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

/** "2026-09-07" → "7. sep." — short Norwegian date for sparkline endpoints. */
export function formatShortDate(isoDate) {
  const MONTHS = ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'];
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(isoDate || ''));
  if (!m) return '';
  const month = MONTHS[Number(m[2]) - 1];
  if (!month) return '';
  return `${Number(m[3])}. ${month}`;
}
